import type { Maybe } from '@amazon/vinyl-util'
import { IllegalStateError, type Unsubscribe } from '@amazon/vinyl-util'

let _reloadApplication: (() => void) | null = null
export function setReloadApplicationHandler(cb: () => Maybe<Unsubscribe>) {
    if (_reloadApplication) throw new IllegalStateError('reload application handler already set')
    _reloadApplication = cb
}

let dispose: Maybe<Unsubscribe> | void = null

export function reloadApplication() {
    dispose?.()
    dispose = _reloadApplication?.()
}
